import * as React from "react";
import { AccountFormSelect } from "./utils";
import { LocaleNames, PreferredLocale } from "../../../utils/locales";

export interface PreferredLanguageSelectorProps {
  onSelectLocale: (newLocale: PreferredLocale | null) => void;
  selectedLocale: PreferredLocale | null;
  setModalMessage: (modalMsg: string) => void;
  supportedLocales: PreferredLocale[];
}

const PreferredLanguageSelector: React.FC<PreferredLanguageSelectorProps> = ({
  selectedLocale,
  setModalMessage,
  supportedLocales,
  onSelectLocale,
}) => {
  const handleOnSelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const { value } = e.target;
    onSelectLocale(value as PreferredLocale);
    setModalMessage("Successfully changed preferred language");
  };

  return (
    <AccountFormSelect
      legend="Preferred Language:"
      name="language"
      footerNote={"The preferred language for learning courses."}
      onChange={handleOnSelect}
      value={selectedLocale ?? PreferredLocale.en}
      data-testid="select-language"
    >
      {...supportedLocales.map(l => (
        <option key={l} value={l}>
          {LocaleNames[l]}
        </option>
      ))}
    </AccountFormSelect>
  );
};

export default PreferredLanguageSelector;
